



















































import { Component, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'
import pdf from 'vue-pdf'
import PrintDialog from './PrintDialog.vue'
import { bidTypes } from '../dictionary'

const baseUrl = 'https://h5.ecom.mgtv.com/ac/file/supplier/'
/** 境内POP店铺合同 */
const CONTRACTS_2 = [
  {
    title: '',
    text: '小芒pop店铺合同电子版',
    src: '2-1-v2.pdf',
    electronic: true,
  },
  // {
  //   title: '',
  //   text: '小芒pop店铺合同纸质版（定版）',
  //   src: '2-2.pdf',
  // },
  // {
  //   title: '',
  //   text: 'MT星球公司商户入驻协议',
  //   src: '2-3.pdf',
  // },
]
/** 一件代发供应商合同 */
const CONTRACTS_3 = [
  {
    title: '',
    text: '小芒电商一件代发业务合同电子版',
    src: '3-1-v2.pdf',
    electronic: true,
  },
  // {
  //   title: '',
  //   text: '《小芒电商纸质合同（代发货） v1.0（法务）》',
  //   src: '3-2.pdf',
  // },
  {
    title: '附件一：',
    text: '商品信息、结算及付款、履约保证金及技术服务费',
    src: '3-f1-v2.pdf',
  },
  // {
  //   title: '附件二：',
  //   text: '《供应商证照清单（法务）》',
  //   src: '3-f2.pdf',
  // },
  // {
  //   title: '附件三：',
  //   text: '《食品和生鲜供应商送货质量标准（法务）》',
  //   src: '3-f3.pdf',
  // },
  // {
  //   title: '附件四：',
  //   text: '《供应商管理规则（法务）》',
  //   src: '3-f4.pdf',
  // },
  // {
  //   title: '附件五：',
  //   text: '《附件五：退换货规则（法务）》',
  //   src: '3-f5.pdf',
  // },
  // {
  //   title: '附件六：',
  //   text: '《关于样品及销售服务费（法务）》',
  //   src: '3-f6.pdf',
  // },
]
/** 跨境平台服务合同 */
const CONTRACTS_6 = [
  {
    title: '',
    text: '小芒电商跨境店铺合同电子版',
    src: '6-1.pdf',
    electronic: true,
  },
  // {
  //   title: '',
  //   text: '小芒电商纸质版平台服务协议（跨境产品）模板 （法务）',
  //   src: '6-2.pdf',
  // },
]
/** 个体工商户合同 */
const CONTRACTS_7 = [
  {
    title: '',
    text: '小芒pop店铺合同电子版',
    src: '7-1-v2.pdf',
  },
]
/** 个人艺术家合同 */
const CONTRACTS_8 = [
  {
    title: '',
    text: '小芒电商POP个人店铺合同电子版',
    src: '8-1-v2.pdf',
    electronic: true,
  },
  // {
  //   title: '',
  //   text: '小芒POP个人店铺合同纸质版',
  //   src: '8-2.pdf',
  // },
]

const contracts: any = {
  2: CONTRACTS_2,
  3: CONTRACTS_3,
  6: CONTRACTS_6,
  7: CONTRACTS_7,
  8: CONTRACTS_8,
}

@Component({
  components: {
    pdf,
    PrintDialog,
  },
})
export default class StepsTwo extends Vue {
  @State bidType!: number
  showFile = false
  pdfSrc = ''
  numPages = null
  printed = false
  viewTime = 10
  timer: any = null
  showPrintDialog = false
  bidTypes = bidTypes

  get pdfList() {
    return contracts[this.bidType] || []
  }

  created() {
    const { NODE_ENV, TARGET } = process.env
    if (NODE_ENV === 'development' || TARGET === 'test-build') {
      this.viewTime = 0
    }

    this.timer = setInterval(() => {
      if (this.viewTime > 0) {
        this.viewTime--
      } else {
        clearInterval(this.timer)
      }
    }, 1000)
  }

  beforeDestroy() {
    clearInterval(this.timer)
  }

  getNumPages() {
    const loadingTask = pdf.createLoadingTask(this.pdfSrc)
    loadingTask.promise
      .then((pdf: any) => {
        this.numPages = pdf.numPages
      })
      .catch((err: any) => {
        this.$message.error('文件加载失败')
        console.error('pdf 加载失败', err)
      })
  }

  onCancel() {
    // contextmenu 禁用右键菜单
    document.oncontextmenu = function (e) {
      return true
    }
  }
  viewPDF(src: string) {
    this.pdfSrc = baseUrl + src
    this.showFile = true
    this.getNumPages()
    // contextmenu 禁用右键菜单
    document.oncontextmenu = function (e) {
      return false
    }
  }
}
